var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiktokFaded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_3724_17209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8136 0.0530813C37.2443 0 40.6552 0.0314556 44.0623 0C44.2687 4.01255 45.7117 8.09981 48.6489 10.9367C51.5801 13.8444 55.7264 15.1753 59.7606 15.6256V26.1809C55.98 26.057 52.1817 25.2706 48.7511 23.6428C47.257 22.9665 45.8651 22.0956 44.5026 21.205C44.4849 28.8644 44.5341 36.514 44.4535 44.142C44.249 47.8066 43.04 51.4534 40.9088 54.4732C37.4802 59.5002 31.5292 62.7775 25.417 62.8797C21.6679 63.094 17.9227 62.0717 14.728 60.1883C9.43361 57.0663 5.70809 51.3512 5.16548 45.2174C5.09714 43.9183 5.08664 42.6169 5.13403 41.3169C5.60586 36.3292 8.07316 31.5578 11.9029 28.312C16.2437 24.5314 22.3245 22.7306 28.018 23.7961C28.071 27.6789 27.9157 31.5578 27.9157 35.4406C25.3147 34.5992 22.2753 34.8351 20.0027 36.4137C18.3399 37.5091 17.0834 39.1207 16.4266 41.0004C15.884 42.3294 16.0393 43.8058 16.0707 45.2174C16.694 49.5189 20.8304 53.1343 25.2459 52.7431C28.1733 52.7117 30.9787 51.0131 32.5043 48.5261C32.9978 47.6552 33.5502 46.7646 33.5797 45.7403C33.8372 41.0515 33.735 36.3823 33.7665 31.6935C33.7881 21.1263 33.735 10.5887 33.8156 0.0550472L33.8136 0.0530813Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3724_17209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.9111,
    height: 62.9111,
    fill: "white",
    transform: "translate(0.966064)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokFaded);
export default __webpack_public_path__ + "static/media/tiktok-faded.66c05971da85083ac435e9c3b587d904.svg";
export { ForwardRef as ReactComponent };